import React from 'react';
import { useSxStyles } from "../styles/sxStyles";
import { getDecimal } from "../config/utils";
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from "@mui/material/Button";
import Tooltip from '@mui/material/Tooltip';
import InstallmentList from "./InstallmentList";
import Zoom from "@mui/material/Zoom";
import Grid2 from '@mui/material/Grid2';

const PlanList = (props) => {
    const plans = props.plans;
    const selectPlan = props.selectPlan;
    const classes = useSxStyles;

    return (<>
        <Typography variant='h6' color='primary' sx={{fontSize: '1.2rem', marginTop: '1rem', marginBottom: '.5rem'}}>Payment Plans</Typography>
        <Paper elevation={3} sx={{...classes.listContainer, maxHeight: '65vh', overflow: 'auto'}}>
            <List sx={classes.list} >
                {plans && plans.length > 0 && plans.map((plan) => {
                    return (!plan.selected ? <>
                        <ListItem alignItems='flex-start' sx={classes.listPadding}>
                            <ListItemText
                                sx={classes.listText}
                                primary={
                                    <Grid2
                                        container
                                        spacing={2}
                                        alignItems="top"
                                        style={{width: '100%'}}
                                    >
                                        <Grid2
                                            size={{
                                                xs: 3,
                                                lg: 2
                                            }}>
                                            <Tooltip title='Add plan to the payment list' arrow slots={{
                                                transition: Zoom
                                            }}>
                                                <Button variant='contained' color='success' onClick={() => selectPlan(plan)} sx={classes.tinyButton}>
                                                    Pay
                                                </Button>
                                            </Tooltip>
                                        </Grid2>
                                        <Grid2
                                            size={{
                                                xs: 9,
                                                lg: 5
                                            }}>
                                            {plan.planDescription}
                                        </Grid2>
                                        <Grid2
                                            size={{
                                                xs: 12,
                                                lg: 5
                                            }}>
                                            <Typography component='span' variant='subtitle2' color='secondary' >
                                                Select one or more installments to pay
                                            </Typography>
                                        </Grid2>
                                    </Grid2>
                                }
                                secondary={ plan.installments &&
                                    <>
                                        <Grid2
                                            container
                                            spacing={2}
                                            alignItems="top"
                                            style={{width: '96%'}}
                                        >
                                            <Grid2 size={12}>
                                                <InstallmentList installments={plan.installments} />
                                            </Grid2>
                                        </Grid2>
                                        { plan.planPaymentServiceFee && plan.planPaymentServiceFee > 0 &&
                                            <Grid2 style={{paddingTop: '0'}} size={12}>
                                                <Typography color='secondary'>
                                                    A payment plan service fee of ${getDecimal(plan.planPaymentServiceFee)} will be added.
                                                </Typography>
                                            </Grid2>
                                        }
                                    </>
                                }
                                slotProps={{
                                    primary: {
                                        component: 'span',
                                        variant: 'subtitle2',
                                        sx: classes.inline,
                                        color: 'textPrimary'
                                    },

                                    secondary: {
                                        component: 'span',
                                        variant: 'body2',
                                        sx: classes.inline,
                                        color: 'textPrimary'
                                    }
                                }} />
                        </ListItem>
                        <Divider/>
                    </> : null);
                })}
            </List>
        </Paper>
    </>);
}

export default PlanList;
